import { useEffect, useRef } from 'react';

import { ICliJob } from 'cli/types';

import { useQuoteVersioningContext } from '../state';
import { VersioningCliJob } from '../versioningCliJobs';

interface IProps {
  initDraftCliJob?: ICliJob | null;
  releaseDraftCliJob?: ICliJob | null;
  resetDraftCliJob?: ICliJob | null;
}

// Runs on every details answer, not only the first: a refetch after a lost status check that
// still reports the job puts the page back in progress.
export const useCheckVersioningPendingCliJobs = ({
  initDraftCliJob,
  releaseDraftCliJob,
  resetDraftCliJob,
}: IProps) => {
  const { resumeVersioningCliJob } = useQuoteVersioningContext();

  const resumeRef = useRef(resumeVersioningCliJob);
  resumeRef.current = resumeVersioningCliJob;

  useEffect(() => {
    if (initDraftCliJob) {
      resumeRef.current(VersioningCliJob.INIT_DRAFT, initDraftCliJob);
    }
  }, [initDraftCliJob]);

  useEffect(() => {
    if (releaseDraftCliJob) {
      resumeRef.current(VersioningCliJob.RELEASE_DRAFT, releaseDraftCliJob);
    }
  }, [releaseDraftCliJob]);

  useEffect(() => {
    if (resetDraftCliJob) {
      resumeRef.current(VersioningCliJob.RESET_DRAFT, resetDraftCliJob);
    }
  }, [resetDraftCliJob]);
};
